import { useMatch, useResolvedPath } from "react-router-dom";
import { Button } from "components";

interface NavItemProps {
  icon: string;
  label: string;
  link: string;
  disabled?: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ icon, label, disabled, link }) => {
  const resolved = useResolvedPath(link);
  const match = useMatch({
    path: resolved.pathname,
    end: resolved.pathname === "/",
  });

  return (
    <Button
      iconFill={match ? 1 : 0}
      iconStart={icon}
      link={link}
      placeContent="flex-start"
      color={match ? "#1565c0" : "#757575"}
      active={Boolean(match)}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default NavItem;
